import './index.erb';
import './index.rb';

(function () {
  'use strict';

  const bindCtaClick = () => {
    $('[data-track-click]').on('click', function () {
      UserTracker.emit('event', {
        eventName: 'contextual offer clicked'
      });
    });
  };

  $(document).on('turbolinks:load', () => {
    bindCtaClick();
  });

  $(document).ready(() => {
    bindCtaClick();
  });
})();
